import { connect } from "react-redux"

export default function buildPermissionHoldersConnector(
    presentationAccessor,
    selectPermissionHolderTypeActionCreator,
    updateChangeModelActionCreator,
    searchAddOwnersViewersActionCreator,
    selectAddOwnerViewerActionCreator,
    applyAddOwnersViewersActionCreator,
    cancelAddOwnersViewersActionCreator
) {
    const mapStateToProps = ({ presentation }) => {
        presentation = presentation[presentationAccessor]
        const { selectedPermissionHolder } = presentation
        return {
            permissionHolders:
                presentation.workingModel[selectedPermissionHolder],
            selectedType: selectedPermissionHolder,
            isFetching:
                presentation.isFetchingOwnersViewersSearch ||
                presentation.isFetchingItem,
            isAdding: presentation.isAddingOwnersViewers,
            searchResults: presentation.ownersViewersSearchResponse.map(
                ownerViewer => ({
                    ...ownerViewer,
                    isAdded: presentation[
                        `${selectedPermissionHolder}ToAdd`
                    ].some(({ id }) => id === ownerViewer.id)
                })
            )
        }
    }

    const mapDispatchToProps = dispatch => ({
        onTypeChange: ({ target: { value } }) =>
            dispatch(selectPermissionHolderTypeActionCreator(value)),
        onRemove: (type, id) => () =>
            dispatch(updateChangeModelActionCreator(type, id)),
        onSearch: ({ target: { value } }) =>
            dispatch(searchAddOwnersViewersActionCreator(value)),
        onChecked: id => () => dispatch(selectAddOwnerViewerActionCreator(id)),
        onApplyAdd: () => dispatch(applyAddOwnersViewersActionCreator()),
        onCancel: () => dispatch(cancelAddOwnersViewersActionCreator())
    })

    return connect(mapStateToProps, mapDispatchToProps)
}
